"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crumblist = exports.defaultCrumbMaps = exports.Container = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var styled_components_1 = __importDefault(require("styled-components"));
var Crumb_1 = require("./Crumb");
exports.Container = styled_components_1.default.div.attrs(function () { return ({
    className: 'tws-crumblist',
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: inline;\n"], ["\n\tdisplay: inline;\n"])));
exports.defaultCrumbMaps = [
    { propertyName: 'displayText', crumbPropertyName: 'displayText' },
    { propertyName: 'value', crumbPropertyName: 'value' },
    { propertyName: 'sequence', crumbPropertyName: 'sequence' },
    { propertyName: 'isDismissible', crumbPropertyName: 'isDismissible' },
    { propertyName: 'count', crumbPropertyName: 'count' },
    { propertyName: 'icon', crumbPropertyName: 'icon' },
];
var Crumblist = /** @class */ (function (_super) {
    __extends(Crumblist, _super);
    function Crumblist(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.mapPropsToState(_this.props);
        _this.handleOnDismiss = _this.handleOnDismiss.bind(_this);
        _this.getCrumbs = _this.getCrumbs.bind(_this);
        _this.mapDataToCrumb = _this.mapDataToCrumb.bind(_this);
        return _this;
    }
    Crumblist.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        this.setState(this.mapPropsToState(props));
    };
    Crumblist.prototype.mapPropsToState = function (props) {
        var dataMaps = props.dataMaps;
        if (!dataMaps || !dataMaps.length) {
            dataMaps = __spreadArray([], exports.defaultCrumbMaps, true);
        }
        return {
            dataMaps: dataMaps,
            crumbs: this.getCrumbs(props, dataMaps),
        };
    };
    Crumblist.prototype.getCrumbs = function (props, dataMaps) {
        var _this = this;
        var data = props.data, enableDismiss = props.enableDismiss;
        var crumbs = lodash_1.default.map(data, function (d) { return _this.mapDataToCrumb(d, dataMaps, enableDismiss); });
        return lodash_1.default.reject(crumbs, function (c) { return !c.displayText || !c.value; });
    };
    Crumblist.prototype.mapDataToCrumb = function (d, dataMaps, enableDismiss) {
        var crumb = {
            displayText: '',
            value: null,
            isDismissible: enableDismiss,
        };
        lodash_1.default.each(dataMaps, function (m) {
            if (Object.prototype.hasOwnProperty.call(d, m.propertyName)) {
                crumb[m.crumbPropertyName] = d[m.propertyName];
            }
        });
        return crumb;
    };
    Crumblist.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, rest = __rest(_a, ["data"]);
        var orderedCrumbs = lodash_1.default.orderBy(this.state.crumbs, ['sequence', 'displayText']);
        return (React.createElement(exports.Container, __assign({}, rest), lodash_1.default.map(orderedCrumbs, function (crumb, index) { return (React.createElement(Crumb_1.Crumb, { key: index, crumb: __assign({}, crumb), onDismiss: _this.handleOnDismiss })); })));
    };
    Crumblist.prototype.handleOnDismiss = function (value) {
        var _a = this.props, data = _a.data, update = _a.update;
        var dataMaps = this.state.dataMaps;
        var map = lodash_1.default.find(dataMaps, function (m) { return m.crumbPropertyName === 'value'; }) || {
            propertyName: 'value',
            crumbPropertyName: 'value',
        };
        if (update) {
            var updated = lodash_1.default.reject(data, function (d) { return d[map.propertyName] === value; });
            update(updated);
        }
    };
    return Crumblist;
}(React.Component));
exports.Crumblist = Crumblist;
var templateObject_1;
